// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"2bbb38ea","50":"2bbb38ea","88":"c92b4c6d","230":"c92b4c6d","264":"78f57da2","276":"2bbb38ea","450":"b4b2c7c0","487":"2bbb38ea","510":"2bbb38ea","908":"2bbb38ea"}[chunkId] + ".chunk.css";
};